<app-maintenance-banner></app-maintenance-banner>
@if (isLogged && isContractSelected) {
  <div class="header">
    <div class="h-4rem">
      <img class="max-h-full" src="/assets/logo-suez-original.png" alt="logo suez" />
    </div>

    <div class="h-4rem">
      <img class="max-h-full" src="/assets/logo-g2fm.png" alt="logo g2fm" />
    </div>

    <div class="title h-4rem p-2">
      <h1 class="hidden md:block">Recyclage et valorisation des déchets</h1>
      <h1 class="block md:hidden">G2FM</h1>
    </div>

    <div class="contextbar h-4rem min-w-max">
      <app-contextbar></app-contextbar>
    </div>
  </div>
  <app-navbar></app-navbar>
}

<router-outlet />

<app-footer></app-footer>
